import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { useParams } from "react-router-dom"
import { useGetInstence } from "../../../hooks/useGetInstence"
import { useState } from "react";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import ResultHandler from "../../../components/ResultHandler";
import { getCar } from "../../../api/cars";
import { INFO_FIELDS } from "./CONSTANT";
import { formatCurrency } from "../../../utils/formatCurrency";
import { ZoomImage } from "../../../components/zoom-image/ZoomImage";

export default function CarDetails(){
    const {id: carId} = useParams()
    const [car, setCar] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getCar,
        carId,
        response => {
            setCar({
                ...response.data.car,
            })
        }
    )

    const [carInfoOpen, setCarInfoOpen] = useState("open")
    const [carImgOpen, setCarImgOpen] = useState("open")

    return(
        <div className="page-content company-profile-page">
            <div className="container-fluid">
                <Breadcrumb title="" breadcrumbItem={"Car Details"} />
                <ResultHandler loading={instenceLoading} />

                <Container fluid>
                    {car && <>
                        <Row>
                           <Col md={car.picture ? 6 : 12} lg={car.picture ? 8 : 12}>
                                <Accordion style={{marginBottom: "20px"}} open={carInfoOpen} toggle={() => setCarInfoOpen(i => i ? null : "open" )}>
                                    <AccordionItem>
                                        <AccordionHeader targetId="open">
                                            <h5 className="mb-0 text-uppercase">Car Info</h5>
                                        </AccordionHeader>
                                        <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                            {INFO_FIELDS.map(f => <Row className="mb-1" key={f.key}>
                                                <Col xs={6}>
                                                    <Label className="mb-0">{f.label}</Label>
                                                </Col>
                                                <Col xs={6}>
                                                    <span style={{fontWeight: "bold"}}>
                                                        {
                                                            f.type === 'price'
                                                            ? formatCurrency(car[f.key])
                                                            : typeof car[f.key] === 'boolean'
                                                            ? car[f.key] ? 'Yes' : 'No'
                                                            : car[f.key]
                                                        }
                                                    </span>
                                                </Col>
                                            </Row>)}  
                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </Col>
                            
                            {car.picture && (
                                <Col md={6} lg={4}>
                                    <Accordion style={{marginBottom: "20px"}} open={carImgOpen} toggle={() => setCarImgOpen(i => i ? null : "open" )}>
                                        <AccordionItem>
                                            <AccordionHeader targetId="open">
                                                <h5 className="mb-0 text-uppercase">Picture</h5>
                                            </AccordionHeader>
                                            <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                                <ZoomImage src={car.picture} alt="car image" width="100%"/>
                                            </AccordionBody>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            )}
                        </Row>
                    </>}
                </Container>
            </div>
            
        </div>
    )
}